export default {
    "frame": {
        "width": 16,
        "height": 9,
    },

    // Hi-fi Isometric
    "canvas": {
        "width": 16 * 135,
        "height": 9 * 135,
        "isPixelated": false,
    },
    "grid": {
        "width": 276,
        "height": 159,
        "depth": 159,
    },
    "camera": {
        "type": "isometric"
    },

    // // Lo-fi Top-down
    // "canvas": {
    //     "width": 16 * 16,
    //     "height": 9 * 16,
    //     "isPixelated": true,
    // },
    // "grid": {
    //     "width": 16,
    //     "height": 16,
    //     "depth": 16,
    // },
    // "camera": {
    //     "type": "top-down"
    // },
}
